import { Popconfirm, Tooltip } from "antd";
import React from "react";
import { useCancelFulfillments } from "./store";
import { toast } from "react-toastify";

function CancelFullfilment({ order, buttonText }) {
  const { updateCancelFullfiment } = useCancelFulfillments();

  const handleConfirm = () => {
    if (order?.order_number) {
      updateCancelFullfiment(order?.order_number, toast);
    }
  };

  return (
    <div>
      <span
        className={`mt-n1 bg-primarytext-white p-2 mt-n2 bg-primary text-white fs-3 rounded-circle d-flex justify-content-center align-items-center shadow`}
        id="cancel-full-fillment"
      >
        <Popconfirm
          title="Cancel Fulfillment"
          description="Are you sure to cancel fulfillment?"
          onConfirm={handleConfirm}
          okText="Yes"
          cancelText="No"
        >
          <Tooltip placement="top" title="Cancel Fulfillment">
            {buttonText}
          </Tooltip>
        </Popconfirm>
      </span>
    </div>
  );
}

export default CancelFullfilment;
